import { forwardRef } from 'react'
import ExecutiveSummaryPage from './ExecutiveSummaryPage'
import GrowthProjectionPage from './GrowthProjectionPage'
import ValueBreakdownPage from './ValueBreakdownPage'
import ResearchEvidencePage from './ResearchEvidencePage'
import YearByYearPage from './YearByYearPage'
import type { ReportData, BrandingConfig } from '@/types'

interface PDFDocumentProps {
  data: ReportData
  branding: BrandingConfig
}

/**
 * Complete PDF document composed of all report pages
 * This component is rendered off-screen and captured for PDF generation
 */
const PDFDocument = forwardRef<HTMLDivElement, PDFDocumentProps>(({ data, branding }, ref) => {
  const totalPages = 5

  return (
    <div
      ref={ref}
      className="pdf-document"
      style={{
        width: '210mm',
        backgroundColor: branding.theme === 'light' ? '#ffffff' : '#1a1f2e',
      }}
    >
      <ExecutiveSummaryPage
        data={data}
        branding={branding}
        pageNumber={1}
        totalPages={totalPages}
      />
      <GrowthProjectionPage
        data={data}
        branding={branding}
        pageNumber={2}
        totalPages={totalPages}
      />
      <ValueBreakdownPage
        data={data}
        branding={branding}
        pageNumber={3}
        totalPages={totalPages}
      />
      <ResearchEvidencePage
        data={data}
        branding={branding}
        pageNumber={4}
        totalPages={totalPages}
      />
      <YearByYearPage
        data={data}
        branding={branding}
        pageNumber={5}
        totalPages={totalPages}
      />
    </div>
  )
})

PDFDocument.displayName = 'PDFDocument'

export default PDFDocument
